import Vue from "vue";
import "./modules/common";
import Ecommerce from "spiritweb.packages.ecommerce";
import VueApp from "~/Scripts/new/vueApp";
import BabcockCheckoutPage from "~/Components/CheckoutPage.vue";
import idPlugin from "~/Scripts/plugins/idPlugin";
import MessageBanner from "~/Components/Common/MessageBanner.vue";
import { upperFirst } from "scule";

Vue.use( idPlugin );
Vue.use( Ecommerce );

new VueApp( {
  name: "Checkout",
  components: {
    BabcockCheckoutPage,
    MessageBanner
  },
  methods: {
    upperFirst ( val ) {
      if ( !val || typeof val !== "string" ) {
        return val;
      }
      return upperFirst( val.toLowerCase() );
    }
  },
  provide () {
    return {
      formatProgressStepFn: this.upperFirst,
      formatStepHeadingFn: this.upperFirst
    };
  }
} );
